import { instructor } from "../data/courseData";
import { Award } from "lucide-react";

export const InstructorCard = () => {
  return (
    <section
      id="instructor"
      data-testid="instructor-section"
      className="relative py-24 md:py-32 px-6 md:px-12 lg:px-16 max-w-7xl mx-auto"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        {/* Image */}
        <div className="lg:col-span-5 relative">
          <div className="relative w-full max-w-md mx-auto lg:max-w-none aspect-[4/5] rounded-3xl overflow-hidden border border-white/[0.08]">
            <img
              src={instructor.photo}
              alt={instructor.name}
              className="w-full h-full object-cover grayscale-[40%] hover:grayscale-0 transition-all duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/80 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#C5A059]/20 border border-[#C5A059]/40 backdrop-blur-md flex items-center justify-center">
                <Award className="w-4 h-4 text-[#C5A059]" strokeWidth={1.6} />
              </div>
              <div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#C5A059] font-semibold">
                  Your instructor
                </div>
                <div className="text-white font-heading text-lg font-semibold mt-0.5">
                  {instructor.name}
                </div>
              </div>
            </div>
          </div>
          {/* Decorative glow */}
          <div
            aria-hidden
            className="absolute -inset-6 -z-10 rounded-[2rem] opacity-30 blur-2xl"
            style={{
              background:
                "radial-gradient(ellipse at center, rgba(197,160,89,0.4) 0%, transparent 70%)",
            }}
          />
        </div>

        {/* Content */}
        <div className="lg:col-span-7">
          <div className="text-xs uppercase tracking-[0.25em] text-[#C5A059] font-semibold mb-5">
            Meet your engineer
          </div>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-white leading-[1.05]">
            7 years of platinum
            <br />
            <span className="gold-text italic font-light">vocal</span> craft.
          </h2>
          <p className="mt-8 text-zinc-400 text-base md:text-lg leading-relaxed max-w-2xl">
            {instructor.bio}
          </p>

          <div className="mt-10">
            <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-semibold mb-5">
              Selected credits
            </div>
            <div
              data-testid="instructor-social-proof"
              className="flex flex-wrap gap-x-6 gap-y-3"
            >
              {instructor.socialProof.map((artist, idx) => (
                <span
                  key={artist}
                  className="font-heading text-zinc-300 text-base md:text-lg font-light tracking-wide flex items-center"
                >
                  {artist}
                  {idx !== instructor.socialProof.length - 1 && (
                    <span className="text-[#C5A059] ml-6">·</span>
                  )}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};